<template>
    <nav class="top-item--menu">
        <ul class="menu--elements">
            <li class="menu--element">
                <router-link :to="{ name: 'user.index' }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('user.index')">Usuarios
                </router-link>
            </li>

            <li v-if="can('expedient.index')" class="menu--element">
                <router-link :to="{ name: 'expedient.index', query: { page: 1 } }"
                             class="menu--element-link btn btn-secondary"
                >Expedientes
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'client.index', query: { page: 1 } }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('client.index')">Clientes
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'entity.index', query: { page: 1 } }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('entity.index')">Entidades
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'lawyer.index', query: { page: 1 } }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('lawyer.view')">Letrados
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'attorney.index', query: { page: 1 } }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('attorney.view')">Procuradores
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'template.index' }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('template.view')">Plantillas
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'task.index' }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('task.view')">Tareas
                </router-link>
            </li>

            <li class="menu--element">
                <router-link :to="{ name: 'burofax.index' }"
                             class="menu--element-link btn btn-secondary"
                             v-if="can('burofax.index.admin')">Burofaxes
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { can } from "../../helpers/Permissions";

export default {
    name: "TheMenu",
    methods: {
        logout() {
            this.$refs.logoutForm.submit();
        },
    },
    inject: ['_csrf_token', '_user_token'],
    data() {
        return {
            userRol: null,
        }
    },
    computed: {
        user() {
            return window.user;
        }
    },
    setup() {
        return {
            can,
        }
    }
}
</script>
